const faqs = [
  {
    id: 1,
    heading: 'For how many days can I reserve a rental car?',
    content: 'You can reserve a rental car for as little as one day or for several weeks, depending on your needs. Long-term rental plans are also available at discounted rates.',
  },
  {
    id: 2,
    heading: 'How to book a car?',
    content: 'Booking a car is simple—just select your preferred vehicle, choose your pickup and return dates, fill in your details, and confirm your reservation online or by phone.',
  },
  {
    id: 3,
    heading: 'Can I cancel my reservation?',
    content: 'Yes, you can cancel your reservation. Most cancellations are free if made within the allowed time frame. Please check the cancellation policy for your specific booking.',
  },
  {
    id: 4,
    heading: 'Can I pay by credit card?',
    content: 'Absolutely! We accept all major credit cards for payments and security deposits. Your card will be charged only after booking confirmation.',
  },
];

export default faqs;